'use client';

import { redirect } from 'next/navigation';
import { Group, Pagination } from '@mantine/core';

export function PageChanger({
  totalPages,
  currentPage,
  link,
}: {
  totalPages: number;
  currentPage: number;
  link: string;
}) {
  return (
    <Group justify='flex-end'>
      <Pagination
        size='lg'
        style={{ float: 'right' }}
        total={totalPages}
        value={currentPage}
        onChange={(value) => redirect(`${link}/${value}`)}
      />
    </Group>
  );
}

export default PageChanger;
